import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import { nullToEmptyString } from "../../../setup/helpers";
import { getImageSource } from "../api/routes";
import { messageShow, upload } from '../../common/api/actions';
import { Typography, Button, TextField, Toolbar, IconButton } from "@mui/material";
import Grid from "@material-ui/core/Grid/Grid";
import ArrowBack from '@mui/icons-material/ArrowBack';
import ImageComp from '../../common/Image';
import FileUpload from '@mui/icons-material/FileUpload';
import styles from "./styles";

import routes from "../api/routes";
import { getbotSettings } from "../api/actions/query";
import { createOrUpdatebotSetting } from "../api/actions/mutation"


class botSettings extends Component {
    constructor(props) {
        super(props);

        this.bot = {
            botName: "",
            image: "default.jpg",
            unknownIntentMessage: "",
            geminiApiKey: "",
            daisyAgentPrefix: "",
            daisyBearerToken: ""
        };
        this.state = {
            isLoading: false,
            isUploadingFile: false,
            bot: this.bot,
            previewImage: null,
            permissions: props.location.state?.permissions || { canEdit: false }
        }
    }

    async componentDidMount() {
        this.refresh();
    }

    refresh = async () => {
        const { getbotSettings, messageShow } = this.props;

        this.isLoadingToggle(true);

        try {
            const { data } = await getbotSettings();
            if (data.success && data.data) {
                this.setState({
                    bot: data.data,
                });
            }
        } catch (error) {
            messageShow("Some error occurred. Please try again.");
        } finally {
            this.isLoadingToggle(false);
        }
    };
    
    isLoadingToggle = (isLoading) => {
        this.setState({
          isLoading,
        });
    };

    isUploadingFileToggle = (isUploadingFile) => {
        this.setState({
            isUploadingFile,
        });
    };

    onUpload = async (event) => {
        const { upload, messageShow } = this.props;
        messageShow("Uploading file, please wait...");
        this.isUploadingFileToggle(true);
        const imgFile = event.target.files[0];
      
        let file = new FormData();
        file.append("type", "bot");
        file.append("name", this.state.bot.botName.trim().replace(/\s+/g, '_') || `bot_${Date.now()}`);
        file.append("file", imgFile);
        const fileReader = new FileReader();
        fileReader.onload = () => {
            const fileResult = fileReader.result;
            let dataAsImg = new Image();
            dataAsImg.src = fileResult;
            this.setState({ previewImage: dataAsImg.src });
        };
        fileReader.readAsDataURL(imgFile);
      
        // Upload image
        try {
            const { data } = await upload(file);
            if (data.success) {

                this.props.messageShow("File uploaded successfully.");
                const { bot } = this.state;
                setTimeout(() => {
                    bot.image = data.file;
                    this.setState({
                        bot,
                    });
                }, 1000);
            } else {
                messageShow("There was some error. Please try again.");
            }
        } catch (error) {
            messageShow("There was some error. Please try again");
            console.error("Error uploading file: ", error)
        } finally {
            this.isUploadingFileToggle(false);
        }
    };

    onType = ({ target: { name, value } }) => {
        this.setState((prevState) => ({
            bot: {
                ...prevState.bot,
                [name]: value,  
            },
        }));
    };

    onCreateOrUpdate = async (event) => {
        event.preventDefault(); 
    
        const { createOrUpdatebotSetting, messageShow, history } = this.props;
        const { bot } = this.state;
    
        this.isLoadingToggle(true);
    
        try {
            const { data } = await createOrUpdatebotSetting(bot);
    
            if (data.success) {
                messageShow(data.message);
                this.refresh(); 
                history.push(routes.intentsList.path);
            } else {
                messageShow("Failed to save bot settings.");
            }
        } catch (error) {
            console.error("Error saving bot settings:", error);
            messageShow("Some error occurred. Please try again.");
        } finally {
            this.isLoadingToggle(false);
        }
    };
    

    render() {
        const { classes } = this.props;
        const { bot, permissions } = this.state;
      
        return (
            <div>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        className={classes.menuButton}
                        color="inherit"
                        onClick={() => this.props.history.push("/intents")}
                    >
                        <ArrowBack />
                    </IconButton>

                    <Typography variant="h6" sx={{ color: '#0d3559', fontWeight: 600 }} className={classes.grow}>
                        Bot Settings
                    </Typography>
                </Toolbar>

                <Grid item xs={12} lg={6}>
                    <SectionPaper padding>
                        <form onSubmit={this.onCreateOrUpdate}>

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"botName"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.botName)}
                                    onChange={this.onType}
                                    label={"Bot Name"}
                                    placeholder={"Enter Bot Name"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    autoFocus
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>
                             
                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"unknownIntentMessage"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.unknownIntentMessage)}
                                    onChange={this.onType}
                                    label={"Custom Unknown Intent Message"}
                                    placeholder={"Enter custom message for unknown intents"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    multiline
                                    rows={2}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"geminiApiKey"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.geminiApiKey)}
                                    onChange={this.onType}
                                    label={"Gemini API Key"}
                                    placeholder={"Enter Gemini API Key"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            {/* Daisy Settings */}
                            {/* <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"daisyAuthKey"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.daisyAuthKey)}
                                    onChange={this.onType}
                                    label={"Daisy Auth Key"}
                                    placeholder={"Enter Daisy Auth Key"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"daisyClientId"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.daisyClientId)}
                                    onChange={this.onType}
                                    label={"Daisy Client ID"}
                                    placeholder={"Enter Daisy client ID (e.g. sys_5c4018)"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"daisyAgentUrl"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.daisyAgentUrl)}
                                    onChange={this.onType}
                                    label={"Daisy Agent URL"}
                                    placeholder={"Enter Daisy Agent URL (e.g. https://test-daisy.datumart.com)"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                />
                            </Grid> */}

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"daisyAgentPrefix"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.daisyAgentPrefix)}
                                    onChange={this.onType}
                                    label={"Daisy Agent Prefix (Blog Generation)"}
                                    placeholder={"Enter Daisy Agent Prefix (e.g. dat_69d277)"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"daisyBearerToken"}
                                    variant="standard"
                                    value={nullToEmptyString(bot?.daisyBearerToken)}
                                    onChange={this.onType}
                                    label={"Daisy Bearer Token (Blog Generation)"}
                                    placeholder={"Enter Daisy Bearer Token"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            <Grid
                                container
                                spacing={8}
                                className={classes.buttonUpload}
                                alignItems="center"
                            >
                                <Grid item xs={12}>
                                   <Typography variant="body1" gutterBottom>
                                     Bot Avatar
                                   </Typography>
                                </Grid>
                                <Grid item md={6} >
                                    {!this.state.previewImage ? (
                                        <ImageComp
                                            src={getImageSource(`${bot.image}`)}
                                            defaultSrc={getImageSource()}
                                            size={"100%"}
                                        />
                                    ) : (
                                        <img
                                            height="auto"
                                            width="100%"
                                            src={this.state.previewImage}
                                            alt="preview_avatar"
                                        ></img>
                                    )}
                                </Grid>
                                <Grid item md={6}>
                                    <input
                                        accept={"image/png,image/jpeg"}
                                        style={{ display: "none" }}
                                        id={"contained-button-file"}
                                        type={"file"}
                                        onChange={this.onUpload}
                                        disabled={!permissions.canEdit}
                                    />

                                    <label htmlFor={"contained-button-file"}>
                                        <Button
                                            variant={"outlined"}
                                            component={"span"}
                                            type={"file"}
                                            fullWidth
                                            disabled={!permissions.canEdit}
                                        >
                                            <FileUpload
                                                fontSize="16"
                                                style={{ marginInlineEnd: 16 }}
                                            />
                                            Upload Image
                                        </Button>
                                    </label>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: 44 }} className={classes.buttonsContainer}>
                                <Button
                                    type={"button"}
                                    aria-label={"Close"}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => this.props.history.push("/intents")}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    style={{ marginInlineStart: 12 }}
                                    type={"submit"}
                                    aria-label={"Save"}
                                    color={"primary"}
                                    variant="contained"
                                    disabled={!permissions.canEdit}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </form>
                    </SectionPaper>
                    </Grid>
            </div>
        );
    }
}

botSettings.propTypes = {
    messageShow: PropTypes.func.isRequired,
    getbotSettings: PropTypes.func.isRequired,
    createOrUpdatebotSetting : PropTypes.func.isRequired,
};

export default connect(null, { messageShow, upload, getbotSettings, createOrUpdatebotSetting  })(
    withRouter(withStyles(styles)(botSettings))
);